import {getUser, getStudent, getCommonUser} from '../../../common/UserService';
import Utils from 'common/Utils';

export const model = {
  step: 'role-select',
  role: '',
  account: {
    username: '',
    email: '',
    first: '',
    last: '',
    password: '',
    age: '',
    classcode: ''
  },
  classroom: {
      name: '',
      grade: '',
      school: '',
      under_13: true
  },
  students: [],
  isManuallyCreatedStudents: true
};
const user = getUser();
if (user) {
  const userSettings = user.userSettings ? JSON.parse(user.userSettings) : {}
  const commonUser = getCommonUser();
  const student = getStudent();
  model.account.username = user.username;
  model.account.first = user.firstName;
  model.account.last = user.lastName;
  model.account.email = user.email;
  model.account.school = userSettings.school_name;
  model.account.job = userSettings.job_title;
  const userAge =  student ? Utils.getAgeFromBirthdate(student.dob) : 0;
  if (userAge > 0) {
    model.account.age = {
      displayName:  userAge < 21 ? userAge.toString() : '21 or older',
      value: userAge
    };
  }
  model.role = (commonUser && commonUser.role) ? commonUser.role.toLowerCase() : '';
}
window.model = model;
